import { createSelector } from 'reselect';
import { get } from 'lodash';

/**
 * Direct selector to the templatePreviewPage state domain
 */
const selectTemplatePreviewPageDomain = (state) =>
  get(state, 'templatePreviewPage');

/**
 * Other specific selectors
 */

/**
 * Default selector used by TemplatePreviewPage
 */

const makeSelectTemplatePreviewPage = createSelector(
  selectTemplatePreviewPageDomain,
  (substate) => substate,
);

const makeSelectTemplateVariableQuestionGroups = createSelector(
  selectTemplatePreviewPageDomain,
  (substate) => get(substate, 'template.variablesTemplate', []),
);

export default makeSelectTemplatePreviewPage;
export {
  selectTemplatePreviewPageDomain,
  makeSelectTemplateVariableQuestionGroups,
};
